import React, { useEffect, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import OnePage from './OnePage';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

const LoadingSpinner = () => (
  <div className='w-full h-screen flex items-center justify-center'>
    <span className='loader'></span>
  </div>
);

const PrivacyPolicyLazy = React.lazy(() => import('./views/privacy-policy/Privacy-Policy'));
const GlossarioLazy = React.lazy(() => import('./views/glossario/Glossario'));
const TeamLazy = React.lazy(() => import('./views/team/TeamView'));

const App = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <HelmetProvider>
      <div className='font-Gilroy'>
        <BrowserRouter basename="/">
          <Routes>
            <Route path="/*" element={<OnePage />} />
            <Route path="/privacy" element={
              <Suspense fallback={<LoadingSpinner />}>
                <PrivacyPolicyLazy />
              </Suspense>
            } />
            <Route path="/glossario" element={
              <Suspense fallback={<LoadingSpinner />}>
                <GlossarioLazy />
              </Suspense>
            } />
            <Route path="/chi-siamo" element={
              <Suspense fallback={<LoadingSpinner />}>
                <TeamLazy />
              </Suspense>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
};

export default App;
